import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  white?: boolean;
  panelPadding?: number;
  centerContent?: boolean;
}

const LeftPanel = styled.div`
  text-align: center;
  box-sizing: border-box;
  flex: 1 1 60%;
  height: 100%;
  ${({ white, panelPadding = 30, centerContent }: IProps) => `
    padding: ${panelPadding}px;
    background-color: ${theme.color.white};
    ${centerContent &&
      `
      display: flex;
      justify-content: center;
    `}
  `};
`;

LeftPanel.defaultProps = { panelPadding: 30 };

export default LeftPanel;



// WEBPACK FOOTER //
// ./src/components/common/RightLeftLayout/Panels/LeftPanel.tsx